// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-form{width:inherit}.login-form__wrapper{width:100%}.login-form__snackbar .v-icon{margin-right:.5rem}.login-form__snackbar .v-snack__content{justify-content:start}", ""]);
// Exports
module.exports = exports;
